function HeroPitch() {
  return (
    <div className="hero-wrapper"> 
         <section className="container-fluid px-4 py-5 hero-card">
            <div className="row">
                <div className="col-12">
                <p className="lh-sm text-center text-md-start">
                    Full-stack Software Engineer with 6+ years building across frontend and backend. Designed, implemented, and tested
                    features for Oracle Fusion Cloud ERP, an enterprise platform used by organizations globally, implemented features and
                    rapid prototyping for performance and interaction evaluation on Microsoft Mesh, and shipped production features to
                    Qualcomm hardware deployed worldwide. Comfortable owning a REST API or a real-time 3D component. Quick to ramp on
                    new stacks and currently deepening backend expertise across Python, Django, and Spring.                
                </p>
                <br/>
                <p className="hero-invite">
                    🚀 Long-Term Direction:
                    Becoming a backend-strong full-stack engineer with architectural depth designing systems, not just features.
                </p>
                </div>
            </div>
        </section>
    </div>
  );
}

export default HeroPitch;
